import template from './goalSetterSidebar.html';
import controller from './goalSetterSidebarCtrl';
import './style.scss';

export default {
  template,
  controller,
  controllerAs: 'vm',
  bindings: {
    loanAppId: '<',
    isGoalSetterEnabled: '<',
    familyId: '<',
  },
};
